module.exports = __webpack_public_path__ + "img/detail-bg.90fd3cfb.png";